import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import api from '../api';

// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/user';
import moment from 'moment';
import { updateGameAction } from 'src/redux/actions/masterGameAction';
import CreateAndUpdateGameTypeModal from 'src/sections/@dashboard/gameTypes/CreateAndUpdateGameTypeModal';
import WithdrwalShowDataModal from 'src/sections/@dashboard/withdrawal/WithdrwalShowDataModal';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { getUTCConvertedDate, row_per_page_data } from 'src/utils/commonUtils';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'user_name', label: 'User Name', alignRight: false },
  { id: 'user_mobile', label: 'User Mobile', alignRight: false },
  { id: 'request_points', label: 'Points', alignRight: false },
  { id: 'date', label: 'Date', alignRight: false },
  { id: 'request_number', label: 'Request Number', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'action', label: 'Action', alignRight: true },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function WalletRequestPage() {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(row_per_page_data[0]);

  const [withdrawalReq, setWithdrawalReq] = useState([]);

  const [selectedGame, setSelectedGame] = useState('');

  const [startDate, setStartDate] = useState();

  const [endDate, setEndDate] = useState();

  const [statusVal, setStatusVal] = useState('pending');

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = withdrawalReq.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const getAllWalletReq = async () => {
    dispatch(loadingStartAction());
    const reqBody = {
      status: 'pending',
    };
    const response = await api.get('/wallet/status-by', reqBody);
    setWithdrawalReq(response.data);
    dispatch(loadingStopAction());
  };

  useEffect(() => {
    getAllWalletReq();
  }, []);

  const deleteGame = async () => {
    // handleCloseMenu();
    // dispatch(loadingStartAction());
    // const response = await api.delete(`/withdrawal/${selectedGame._id}`);
  };

  const editWalletReq = async (item, status) => {
    let reqBody = {
      transaction_type: 'credit',
      status: status?.toLowerCase(),
      user_id: item.user._id,
    };

    dispatch(loadingStartAction());
    await api.put(`/wallet/${item._id}`, reqBody);
    getAllWalletReq();
  };

  const getAllFilteredData = async () => {
    dispatch(loadingStartAction());
    const response = await api.get(
      `/withdrawal/withdrawals?startDate=${getUTCConvertedDate(startDate)}&endDate=${getUTCConvertedDate(endDate)}`
    );
    setWithdrawalReq(response.data);
    dispatch(loadingStopAction());
  };

  const getAllFilteredByStatusData = async (status) => {
    if (status === 'all') {
      getAllWalletReq();
      return;
    }
    dispatch(loadingStartAction());
    const response = await api.get(`/withdrawal/withdrawals?status=${status}`);
    setWithdrawalReq(response.data);
    dispatch(loadingStopAction());
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - withdrawalReq?.length) : 0;

  const filteredFinalData = applySortFilter(withdrawalReq, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredFinalData.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> User | Minimal UI </title>
      </Helmet>

      <Container>
        <Card>
          {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={withdrawalReq.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredFinalData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id, user, status, points, createdAt, payment_method } = row;
                    const selectedUser = selected.indexOf(user?.name) !== -1;

                    return (
                      <TableRow hover key={_id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          {/* <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, user?.name)} /> */}
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          {user?.name}
                        </TableCell>

                        <TableCell align="left">{user?.email}</TableCell>

                        <TableCell align="left">{points}</TableCell>
                        <TableCell align="left">{moment(createdAt).format('MMM Do, hh:mm a')}</TableCell>
                        <TableCell align="left">{_id}</TableCell>

                        <TableCell align="left">
                          {status?.toLowerCase() === 'rejected' && <Label color={'error'}>{status}</Label>}
                          {status?.toLowerCase() === 'accepted' && <Label color={'success'}>{status}</Label>}
                          {status?.toLowerCase() === 'pending' && <Label color={'info'}>{status}</Label>}
                        </TableCell>

                        <TableCell align="right">
                          <Stack direction="row">
                            <Button
                              onClick={() => editWalletReq(row, 'accepted')}
                              variant="contained"
                              color="success"
                              disabled={status?.toLowerCase() !== 'pending'}
                            >
                              Accept
                            </Button>
                            <Button
                              style={{
                                marginLeft: 10,
                              }}
                              disabled={status?.toLowerCase() !== 'pending'}
                              onClick={() => editWalletReq(row, 'rejected')}
                              variant="contained"
                              color="error"
                            >
                              Reject
                            </Button>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={row_per_page_data}
            component="div"
            count={filteredFinalData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <CreateAndUpdateGameTypeModal selectedGame={selectedGame} />

        <MenuItem onClick={() => deleteGame()} sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
